var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkAddSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 6.836a1 1 0 1 0-2 0v3h-3a1 1 0 0 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3v-3zm-19.666 5a1 1 0 0 0-.894.553l-4 8a1 1 0 0 0-.106.447v8a3.667 3.667 0 0 0 3.667 3.667h1.666v.32a1 1 0 0 0 1 1h3.946a1 1 0 0 0 1-1v-.32h8.721v.32a1 1 0 0 0 1 1h3.946a1 1 0 0 0 1-1v-.32H32a3.667 3.667 0 0 0 3.667-3.667v-8a1 1 0 0 0-.105-.447l-2-4a1 1 0 1 0-1.79.894l1.277 2.553H6.952l3-6h9.674a1 1 0 0 0 0-2H9.334zM29.28 30.503H8a1.667 1.667 0 0 1-1.667-1.667v-7h27.333v7a1.667 1.667 0 0 1-1.666 1.667H29.28zm-15.946-5.667h-2.666v2.667h2.666v-2.667zm2.667 0h2.666v2.667h-2.666v-2.667zm8 0h-2.667v2.667h2.667v-2.667zm2.666 0h2.667v2.667h-2.666v-2.667z",
    fill: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkAddSwitch);
export default __webpack_public_path__ + "static/media/bulkAddSwitch.96f3e22946cbb8c80f9b01d04e1e5d31.svg";
export { ForwardRef as ReactComponent };